// Six stat tiles over the FILTERED selection (recomputes on every filter
// click). Always six, so the column beside the map keeps its shape whatever
// the analysis; the mechanism counters (glare matches, wet surface, ...) live
// in the Insights panel as information chips instead.
import React from 'react';
import { fmtUsd } from './insightsText';

const Tile = ({ value, label, sub, accent }) => (
  <div className={`safety-tile ${accent ? 'safety-tile-accent' : ''}`}>
    <div className="safety-tile-value">{value ?? '—'}</div>
    <div className="safety-tile-label">{label}</div>
    {sub && <div className="safety-tile-sub">{sub}</div>}
  </div>
);

export default function SummaryStats({ stats, analysis, vertical = false, economics }) {
  if (!stats) return null;
  const sev = stats.bySeverity || {};
  const eco = economics || {};
  return (
    <div className={`safety-tiles ${vertical ? 'safety-tiles-vertical' : ''}`}>
      <Tile value={stats.nCrashes} label="Crashes (filtered)"
        sub={stats.corridorMiles != null ? `on ${stats.corridorMiles} mi of selected corridors` : undefined} />
      <Tile value={stats.crashesPerMile} label="Crashes / mile" />
      <Tile value={`${sev.fatal || 0} / ${sev.injury || 0} / ${sev.pdo || 0}`}
        label="Fatal / Injury / PDO" />
      <Tile value={stats.runCount} label={`${analysis} deficiency runs`}
        sub={`${stats.runMiles} mi (${stats.runShareOfCorridor ?? '—'}% of corridor)`} />
      <Tile value={stats.nearShare !== null ? `${stats.nearShare}%` : '—'}
        label="Crashes near a run"
        sub={`within ${stats.nearBufferMi} mi · ${stats.crashesInsideRuns} inside`} />
      {eco.benefitPerYr != null ? (
        <Tile accent
          value={`${fmtUsd(eco.benefitPerYr)} / yr`}
          label="Expected savings"
          sub={<>with countermeasures · correlated crash cost <span className="safety-key-sub">{fmtUsd(eco.correlatedCost || 0)}</span></>} />
      ) : (
        <Tile accent
          value={eco.correlatedCost != null ? fmtUsd(eco.correlatedCost) : '—'}
          label="Social cost at deficiencies"
          sub={`crashes correlated with a deficiency${eco.lives ? ` · ${eco.lives} li${eco.lives === 1 ? 'fe' : 'ves'}` : ''}`} />
      )}
    </div>
  );
}
